import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lightning } from "@phosphor-icons/react";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@asymmetryedits.com");
  const [password, setPassword] = useState("Admin@2026");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen bg-background">
      <div className="relative hidden w-1/2 overflow-hidden lg:block">
        <img src="https://images.pexels.com/photos/1926769/pexels-photo-1926769.jpeg?auto=compress&w=1200" alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-brand-violet/80 via-background/40 to-brand-pink/60" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-display text-4xl font-black leading-tight text-white">Your creative marketing headquarters.</p>
          <p className="mt-3 max-w-md text-white/80">Plan campaigns, create content, run ads, coordinate influencers and measure everything — beautifully.</p>
        </div>
      </div>

      <div className="flex w-full items-center justify-center px-6 lg:w-1/2">
        <div className="w-full max-w-sm" style={{ animation: "fade-up 0.5s ease-out both" }}>
          <div className="mb-8 flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-brand-violet to-brand-pink">
              <Lightning size={22} weight="fill" className="text-white" />
            </div>
            <div>
              <p className="font-display text-lg font-black">Asymmetry Edits</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Marketing OS</p>
            </div>
          </div>

          <h1 className="font-display text-3xl font-black">Welcome back</h1>
          <p className="mt-1 text-sm text-muted-foreground">Sign in to your marketing workspace.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl" required />
            </div>
            <div className="space-y-1.5">
              <Label>Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl" required />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-brand-pink">{error}</p>}
            <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full rounded-full bg-gradient-to-r from-brand-violet to-brand-pink py-6 text-white">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-muted-foreground">
            New here? <Link to="/register" className="font-semibold text-primary">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
